const convertToPyeongPrice = (origin: number) => {
    return Math.round(origin * 3.305785);
};
export default convertToPyeongPrice;
